/**
 * this function only calc field "disabled" and "required" value by enabledWishlist.
 * @param {*} enabledWishlist
 * @param {*} isManual
 * @returns
 */
export function getTenancyFieldsConfig(enabledWishlist, isManual) {
  const config = {
    moveInType: {
      disabled: enabledWishlist,
      required: !enabledWishlist,
    },
    moveIn: {
      disabled: enabledWishlist,
      required: !enabledWishlist,
    },
    tenancyLengthType: {
      disabled: enabledWishlist,
      required: !enabledWishlist,
    },
    tenancyLengthValueMin: {
      disabled: enabledWishlist,
      required: !enabledWishlist,
    },
    tenancyLengthValueMax: {
      disabled: enabledWishlist,
      required: !enabledWishlist,
    },

    moveOutType: {
      disabled: enabledWishlist,
      required: !enabledWishlist,
    },
    moveOut: {
      disabled: enabledWishlist,
      required: !enabledWishlist,
    },
  };

  if (isManual) {
    config.moveInType.disabled = false;
    config.moveIn.disabled = false;
    config.tenancyLengthType.disabled = false;
    config.tenancyLengthValueMin.disabled = false;
    config.tenancyLengthValueMax.disabled = false;
    config.moveOutType.disabled = false;
    config.moveOut.disabled = false;
  }

  return config;
}

/**
 * this function only calc field "disabled" and "required" value by enabledWishlist.
 * @param {*} enabledWishlist
 * @param {*} isManual
 * @returns
 */
export function getAvailabilityAndPriceFieldsConfig(enabledWishlist, isManual) {
  const config = {
    availability: {
      disabled: enabledWishlist,
      required: !enabledWishlist,
    },
    priceType: {
      disabled: enabledWishlist,
      required: !enabledWishlist,
    },
    priceMin: {
      disabled: enabledWishlist,
      required: !enabledWishlist,
    },
    priceMax: {
      disabled: enabledWishlist,
      required: !enabledWishlist,
    },
    discountType: {
      disabled: enabledWishlist,
      required: !enabledWishlist,
    },
    discountValue: {
      disabled: enabledWishlist,
      required: !enabledWishlist,
    },
  };

  if (isManual) {
    config.priceType.disabled = false;
    config.priceMin.disabled = false;
    config.priceMax.disabled = false;
    config.discountType.disabled = false;
    config.discountValue.disabled = false;
  }

  return config;
}
